import { Injectable } from '@angular/core';
import { File } from '@awesome-cordova-plugins/file/ngx';
import { HTTP } from '@awesome-cordova-plugins/http/ngx';
import { ToastController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { CommandService } from './command.service';

@Injectable({
  providedIn: 'root',
})
export class UpdateService extends CommandService {
  constructor(private http: HTTP, private storage: Storage) {
    super(new ToastController());
  }

  file: File = new File();
  content: any;
  contentHex: any;
  offset: any;

  maxSize: any;

  sendMessage() {
    let cmd: any;
    if (typeof this.cmd == 'string') cmd = this.hexTobytes(this.cmd);
    else cmd = this.cmd;

    console.log(cmd);
    this.ble
      .write(
        this.device.bleId,
        this.device.serviceUUID,
        this.device.rxUUID,
        cmd
      )
      .then(
        (data) => {
          console.log('Result Write : ', data);
        },
        (err) => {
          console.log('Write erreur : ', err);
        }
      );
  }

  checkUpdate() {
    this.cmd = '3F2402000D00';
    this.sendMessage();
  }

  getFile(infos: any) {
    console.log(infos);
    let beginCmd = '';

    this.storage.get('updateInfos').then((res) => {
      if (res == null || res.version != infos) {
        this.http
          .sendRequest(
            'https://storage.gra.cloud.ovh.net/v1/AUTH_9d177826801d427c9e69e0ec2e22422a/solupass_firmwares/CarteLoraWan_v' +
            infos +
            '.maj',
            {
              method: 'get',
              responseType: 'arraybuffer',
            }
          )
          .then((res) => {
            const updateInfos = {
              file: res.data,
              version: infos,
            };

            this.storage.set('updateInfos', updateInfos);

            console.log(res);
            this.content = res.data;
            console.log(this.content);

            /* if (infos[0].type == "mainfw") {
        beginCmd = "3E05";
      }    else {
        beginCmd = "3E0A"
      }*/

            beginCmd = '3E05';
            this.offset = 0;

            let z = 0;
            let sizeHex = '';
            while (z + this.content.byteLength.toString(16).length < 8) {
              sizeHex = sizeHex + '0';
              z++;
            }

            sizeHex = sizeHex + this.content.byteLength.toString(16);
            sizeHex = this.littleToBigEndian(sizeHex);

            this.cmd = beginCmd + sizeHex;
            this.maxSize = this.content.byteLength;

            console.log('UPDATE : File Size ', this.maxSize);

            this.sendMessage();
          });
      } else {
        this.content = res.file;
        console.log(this.content);

        /* if (infos[0].type == "mainfw") {
          beginCmd = "3E05";
        }    else {
          beginCmd = "3E0A"
        }*/

        beginCmd = '3E05';
        this.offset = 0;

        let z = 0;
        let sizeHex = '';
        while (z + this.content.byteLength.toString(16).length < 8) {
          sizeHex = sizeHex + '0';
          z++;
        }

        sizeHex = sizeHex + this.content.byteLength.toString(16);
        sizeHex = this.littleToBigEndian(sizeHex);

        this.cmd = beginCmd + sizeHex;
        this.maxSize = this.content.byteLength;

        console.log('UPDATE : File Size ', this.maxSize);

        this.sendMessage();
      }
    });

    this.http
      .sendRequest(
        'https://storage.gra.cloud.ovh.net/v1/AUTH_9d177826801d427c9e69e0ec2e22422a/solupass_firmwares/CarteLoraWan_v' +
        infos +
        '.maj',
        {
          method: 'get',
          responseType: 'arraybuffer',
        }
      )
      .then((res) => {
        const updateInfos = {
          file: res.data,
          version: infos,
        };

        this.storage.set('updateInfos', updateInfos);

        console.log(res);
        this.content = res.data;
        console.log(this.content);

        /* if (infos[0].type == "mainfw") {
        beginCmd = "3E05";
      }    else {
        beginCmd = "3E0A"
      }*/

        beginCmd = '3E05';
        this.offset = 0;

        let z = 0;
        let sizeHex = '';
        while (z + this.content.byteLength.toString(16).length < 8) {
          sizeHex = sizeHex + '0';
          z++;
        }

        sizeHex = sizeHex + this.content.byteLength.toString(16);
        sizeHex = this.littleToBigEndian(sizeHex);

        this.cmd = beginCmd + sizeHex;
        this.maxSize = this.content.byteLength;

        console.log('UPDATE : File Size ', this.maxSize);

        this.sendMessage();
      });
  }

  public checkStatus() {
    this.cmd = '3e0f';
    this.sendMessage();
  }

  public receiveResponse(data: any) {
    const response = this.buf2hex(data).toLowerCase();
    const check = response.substring(0, 2);

    console.log('Response : ', response, ' Check : ', check);

    if (check == '3a') {
      //0x3A (ASCII ":") => envoi d'une donnée
      console.log('Autre type de reponse');
      return response;
    }

    if (check == '3e') {
      //0x3E (ASCII ">") = lancement mise à jour
      const size = this.littleToBigEndian(response.substring(10, 14));
      const offset = this.littleToBigEndian(response.substring(2, 10));

      console.log('Size : ', size, ' Offset : ', offset);
      console.log(
        'Size Dec : ',
        parseInt(size, 16),
        ' Offset Dec : ',
        parseInt(offset, 16)
      );
      const from = parseInt(offset, 16);
      const to = parseInt(offset, 16) + parseInt(size, 16);
      console.log('From : ', from, ' to : ', to);
      //this.cmd = this.contentHex.substring(from, to);
      this.cmd = this.content.slice(from, to);

      console.log('CMD : ', this.cmd);
      this.sendMessage();

      console.log();
      let percent = Math.floor((from * 100) / this.maxSize).toString();
      return percent;
    }
  }
}
